import { CSSProperties } from 'react';
import { VivliOrgNavView } from '@vivli/core/layout';

const containerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    marginRight: 50,
    marginTop: 45.5,
    color: '#03395a'
};

const linkMenuStyle: CSSProperties = { display: 'flex' };

const findStudiesStyle: CSSProperties = {
    marginLeft: 6,
    marginRight: 6,
    fontWeight: 'bold',
    textDecoration: 'none',
    cursor: 'pointer',
    color: '#03395a'
};

const findStudiesArrowStyle: CSSProperties = {
    width: 0,
    height: 0,
    borderLeft: '10px solid transparent',
    borderRight: '10px solid transparent',
    borderBottom: '10px solid #053d58',
    position: 'absolute',
    top: 20,
    marginLeft: 42
};

interface ExternalLinkMenuComponentProps {
    onFindStudiesClick: () => void;
}

export const ExternalLinkMenuComponent = ({ onFindStudiesClick }: ExternalLinkMenuComponentProps) => {
    return (
        <div style={containerStyle}>
            <div style={{ marginTop: -15, paddingRight: 20 }}>
                <VivliOrgNavView />
            </div>

            <div style={{ ...linkMenuStyle, position: 'relative', marginTop: -1 }}>
                <a style={findStudiesStyle} onClick={onFindStudiesClick}>
                    Find Studies
                </a>
                <div style={findStudiesArrowStyle} />
            </div>
        </div>
    );
};
